import React, { useCallback } from "react";
import { Linking } from "react-native";
import useIsSSO from "./useIsSSO";

function useSendSMS() {
  const { authMethod } = useIsSSO();
  const sendSMS = useCallback(
    (message: string) => {
      if (authMethod === "ballpark") {
        window.location.href = `sms:?&body=${encodeURI(message)}`;
      } else {
        Linking.openURL(`sms:?&body=${encodeURI(message)}`);
      }
    },
    [authMethod]
  );

  return sendSMS;
}

export default useSendSMS;
